import { useMutation } from 'react-query';

import { setUserAccountBody } from '../graphql/user-body-input.2';
import * as types from '../graphql/user-body-input_types.2';

export const useSetUserAccountBodyMutation = () => {
  return useMutation<
    types.SetUserAccountBody,
    unknown,
    { variables: types.SetUserAccountBodyVariables }
  >(async ({ variables }) => {
    const { data } = await setUserAccountBody(variables);
    return data;
  });
};

